import { ComponentType } from "react";
import { Building2, Info, Landmark, MapPin, Palette, Users } from "lucide-react";

export interface PlateformeCreateSection {
  id: string;
  number: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
}

/** Sections du formulaire de création, dans l'ordre d'affichage (= ancres). */
export const ORGANIZATION_CREATE_SECTIONS: PlateformeCreateSection[] = [
  { id: 'section-identite', number: '01', label: 'Identité', icon: Building2 },
  { id: 'section-coordonnees', number: '02', label: 'Coordonnées', icon: MapPin },
  { id: 'section-roles', number: '03', label: 'Rôles', icon: Users },
  { id: 'section-comptes-bancaires', number: '04', label: 'Comptes bancaires', icon: Landmark },
  { id: 'section-personnalisation', number: '05', label: 'Personnalisation', icon: Palette },
];

interface PlateformeCreateSectionsMenuProps {
  activeId: string;
  onNavigate: (id: string) => void;
}

/**
 * Menu latéral collant du formulaire de création : sections numérotées,
 * mise en évidence de la section visible, navigation par ancre.
 */
export const PlateformeCreateSectionsMenu: React.FC<PlateformeCreateSectionsMenuProps> = ({
  activeId,
  onNavigate,
}) => (
  <div className="flex-shrink-0 w-56">
    <div className="sticky top-6">
      <p className="px-3 mb-2 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
        Sections
      </p>
      <nav className="flex flex-col gap-1">
        {ORGANIZATION_CREATE_SECTIONS.map((section) => {
          const active = section.id === activeId;
          const Icon = section.icon;
          return (
            <button
              key={section.id}
              type="button"
              onClick={() => onNavigate(section.id)}
              className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-left transition-all duration-200 ${
                active ? 'bg-primary/10' : 'hover:bg-gray-50'
              }`}
            >
              <span
                className={`w-6 h-6 rounded-md flex items-center justify-center text-[10px] font-semibold flex-shrink-0 ${
                  active ? 'bg-primary/15 text-primary' : 'bg-gray-100 text-gray-500'
                }`}
              >
                {section.number}
              </span>
              <Icon className={`w-4 h-4 flex-shrink-0 ${active ? 'text-primary' : 'text-gray-500'}`} />
              <span
                className={`text-sm leading-tight ${
                  active ? 'text-primary font-semibold' : 'text-gray-600 font-medium'
                }`}
              >
                {section.label}
              </span>
            </button>
          );
        })}
      </nav>

      <div className="mt-4 rounded-lg bg-gray-50 border border-gray-200 p-3 flex items-start gap-1.5">
        <Info className="w-3.5 h-3.5 text-gray-400 mt-0.5 flex-shrink-0" />
        <p className="text-xs text-gray-600">
          Les champs marqués <span className="text-red-500 font-semibold">*</span> sont
          obligatoires.
        </p>
      </div>
    </div>
  </div>
);
